package utils

import com.essntl.core.utils.error.UnauthorizedException
import com.essntl.features.authentication.domain.repository.AuthRepository
import com.essntl.toastmanager.ToastManager
import io.github.jan.supabase.auth.status.SessionStatus
import kotlinx.coroutines.flow.collectLatest

suspend fun checkAuth(
    authRepository: AuthRepository,
    isLastItemAuth: () -> Boolean,
    isLastItemSplash: () -> Boolean,
    navigateToHome: () -> Unit,
    navigateToAuth: () -> Unit,
) {
    authRepository
        .verifySession()
        .collectLatest { sessionStatus ->
            when (sessionStatus) {
                is SessionStatus.Initializing -> {
                    println("sessionStatusInitializing $sessionStatus")
                }

                is SessionStatus.Authenticated -> {
                    println("sessionStatusAuthenticated $sessionStatus")
                    if (isLastItemAuth() || isLastItemSplash()) {
                        navigateToHome()
                    }
                }

                else -> {
                    println("sessionStatusNotAuthenticated $sessionStatus")
                    if (!isLastItemAuth()) {
                        navigateToAuth()
                    }
                }
            }
        }
}

suspend fun checkException(
    toastManager: ToastManager,
    navigateToAuth: () -> Unit,
) {
    toastManager
        .throwable
        .collectLatest {
            when (it) {
                is UnauthorizedException -> {
                    println("UnauthorizedException detected, navigating to auth screen...")
                    navigateToAuth()
                }

                else -> Unit
            }
        }
}
